import React, { useState } from 'react';
import Modal from 'components/Core/Modal';
import Cookies from 'js-cookie';
import { emailLookup, createUser, updateUser } from 'services/userService';
import userToolBoxJwt from 'hooks/useToolboxStorage';
import { formSubmittedEvent } from 'services/dataLayerService';
import Signup1 from './Signup1';
import Signup2 from './Signup2';
import Signup3 from './Signup3';
import Signup4 from './Signup4';
import WaitingModalContainer from '../Waiting';

const SignupModal = ({
  isModalOpen,
  handleCloseModal,
  openLoginModal,
  errorMessage,
  setErrorMessage,
  setUserInfo,
  authClient,
  socialAuth,
  initialStep = '',
}) => {
  const [signUpData, setSignupData] = useState({ email: Cookies.get('email') });
  const [step, setStep] = useState(initialStep);

  const gotoStep = (num) => {
    setStep(num);
    setErrorMessage('');
  };

  const Step2 = async ({ password, question, answer }) => {
    try {
      const user = {
        email: signUpData.email,
        password,
        question,
        answer,
      };

      const { sessionToken } = await createUser(user);

      const dataLayerData = {
        event: 'registration completed',
        registration_type: 'toolbox',
        clientId: '1033501218.1368477899',
        email: user.email,
      };

      dataLayer.push(dataLayerData);

      const res = await authClient.token.getWithoutPrompt({
        responseType: 'id_token',
        sessionToken,
      });

      authClient.tokenManager.setTokens(res.tokens);
      userToolBoxJwt.set(res.tokens.idToken.idToken);

      gotoStep('3');
    } catch (error) {
      setErrorMessage(error?.response?.data?.error || error.toString());
    }
  };

  const Step3 = async (data) => {
    try {
      const newData = { ...signUpData, ...data };
      setSignupData(newData);
      gotoStep('4');
    } catch (error) {
      setErrorMessage(error?.response?.data || error.toString());
    }
  };

  const Step4 = async (data) => {
    try {
      const newData = { ...signUpData, ...data };
      setSignupData(newData);
      const user = await updateUser(userToolBoxJwt.get(), newData);

      formSubmittedEvent({
        form_type: 'Toolbox User Data',
        ...newData,
      });

      setUserInfo(user);
      setSignupData({});
      handleCloseModal();
    } catch (error) {
      setErrorMessage(error?.response?.data || error.toString());
    }
  };

  const Step1 = async (email) => {
    try {
      gotoStep('waiting');
      const data = await emailLookup(email);
      setSignupData({ ...data, email });
    } catch (e) {
      setSignupData({ email });
    }
    gotoStep('2');
  };

  const renderStep = () => {
    switch (step) {
      case 'waiting':
        return <WaitingModalContainer />;
      case '2':
        return (
          <Signup2
            onFinish={Step2}
            openLoginModal={openLoginModal}
            errorMessage={errorMessage}
            onBack={() => gotoStep('1')}
          />
        );
      case '3':
        return <Signup3 onFinish={Step3} errorMessage={errorMessage} data={signUpData} />;
      case '4':
        return (
          <Signup4
            onFinish={Step4}
            errorMessage={errorMessage}
            data={signUpData}
            onBack={() => gotoStep('3')}
          />
        );
      default:
        return (
          <Signup1
            socialAuth={socialAuth}
            openLoginModal={openLoginModal}
            onFinish={Step1}
            data={signUpData}
          />
        );
    }
  };

  return (
    <Modal open={isModalOpen} width={658} handleClose={handleCloseModal}>
      <div>{renderStep()}</div>
    </Modal>
  );
};

export default SignupModal;
